import { InitialiseLoginService } from '@app/app-initialisers/initialise-login/initialise-login.service';

export const LoginInit = (initialiseLoginService: InitialiseLoginService) => () => initialiseLoginService.loginInit();
